import React from "react";
import { styled } from '@mui/material/styles';
import { Typography } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
const PREFIX = 'KeyValuePair';

const classes = {
  root: `${PREFIX}-root`,
  value: `${PREFIX}-value`
};

const StyledGrid = styled(Grid)((
  {
    theme
  }
) => ({
  [`&.${classes.root}`]: {
    padding: theme.spacing(0.5),
  },

  [`& .${classes.value}`]: {
    wordBreak: "break-word",
    whiteSpace: "pre-line",
    overflowWrap: "break-word",
    MsWordBreak: "break-word",
    MsHyphens: "auto",
    MozHyphens: "auto",
    WebkitHyphens: "auto",
    hyphens: "auto",
  }
}));

export const KeyValuePair = (props) => {
  const { title, value, xs, sm, md, lg, valueStyle, ...restProps } = props;

  return (
    <StyledGrid
      {...restProps}
      xs={xs ?? 12}
      sm={sm ?? 6}
      md={md ?? 3}
      lg={lg}
      className={classes.root}
    >
      <Typography variant="body2" gutterBottom color="textSecondary">
        {title}
      </Typography>
      <Typography className={classes.value} sx={valueStyle} variant="body1">
        {value !== null ? value : null}
      </Typography>
      {props.children}
    </StyledGrid>
  );
};
